export const exportButtonSx = {
  width: 'auto',
  minWidth: '150px',
  height: '32px',
  padding: '0 12px',
  // marginRight: '10px', // Apply margin individually where needed
  borderRadius: '8px',
  backgroundColor: '#3C96D4',
  color: 'white',
  fontFamily: '"PT Sans", sans-serif',
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: '32px', // Match height
  textTransform: 'none',
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  columnGap: '6px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#2a6d9e',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: 'lightgray',
    color: '#a0a0a0',
  },
}; 